import { Component, Input, OnInit } from '@angular/core';
import { IErrorDescription } from '@ibank-globals/error';
import { LanguageService } from '@ibank-globals/language';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators/finalize';
import { BaseComponent } from '../../../globals/classes/base.component';
import { SourceApis } from '../../../globals/classes/errorDescription';
import { ErrorHandler } from '../../../globals/classes/errorHandler';
import { IGetRegisteredMobileNumbersRequest } from '../../classes/existing-onboarding-customer/requests';
import {
	CreateApplicationResponse,
	GetRegisteredMobileNumbersResponse,
	ICreateApplicationResponse,
	IGetRegisteredMobileNumbersResponse,
} from '../../classes/existing-onboarding-customer/responses';
import { ExistingOnboardingCustomerService } from '../../services/existing-recovery/customer.service';
import { CardDetailsModalComponent } from '../card-details-modal/card-details-modal.component';
import { ContactInfoModalComponent } from '../contact-info-modal/contact-info-modal.component';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'confirm-personal-details-modal',
	template: require('./confirm-personal-details-modal.component.html'),
})
export class ConfirmPersonalDetailsModalComponent extends BaseComponent implements OnInit {
	@Input() appResponse: ICreateApplicationResponse;
	@Input() isCardModalflow: boolean = false;
	@Input() public isForgetCredentialsRetailModalflow: boolean = false;
	public firstname: string;
	public lastname: string;
	public dateOfBirth: string;
	public fathersName: string;
	public idNumber: string;
	public taxNumber: string;
	public getMobileNumberRequest: IGetRegisteredMobileNumbersRequest;
	public isLoading: boolean = false;
	public langId: string;
	public dynatraceForExistingOnBoarding: boolean = AppSettings.dynatraceForExistingOnBoarding;
	public isRebrading = AppSettings.isRebrading;

	constructor(
		private activeModal: NgbActiveModal,
		private modalService: NgbModal,
		private _langSvc: LanguageService
	) {
		super();
	}

	public ngOnInit(): void {
		this.nullableCheck();
		this.initRequests();
		this._initSubscriptions();
	}

	public closeModal(): void {
		this.activeModal.close();
	}

	public toggleCardDetails(): void {
		this.activeModal.close();
		const modalRef = this.modalService.open(CardDetailsModalComponent, {
			windowClass: 'modal-small',
		});
		(modalRef.componentInstance as CardDetailsModalComponent).isCardModalflow =
			this.isCardModalflow;
		(
			modalRef.componentInstance as CardDetailsModalComponent
		).isForgetCredentialsRetailModalflow = this.isForgetCredentialsRetailModalflow;
	}

	public toggleContactInfo(): void {
		if (this.dynatraceForExistingOnBoarding) this._setDetailsConfirmDynatraceEvent();
		this.invokeRegisteredMobileNumber();
	}

	public findNBGStore(): string {
		if (this.langId === 'el') {
			return 'https://www.nbg.gr/el/Branches-ATMs';
		} else return 'https://www.nbg.gr/en/Branches-ATMs';
	}

	public findBranchEvent() {
		if (this.dynatraceForExistingOnBoarding)
			this.setDynatraceEvent('ECO_Personal_Details_Not_Confirm');
	}
	private _setDetailsConfirmDynatraceEvent() {
		this.setDynatraceEvent('ECO_Personal_Details_Confirm');
	}

	private _initSubscriptions(): void {
		this.mortalize(this._langSvc.activeLanguage$).subscribe((lang) => (this.langId = lang));
	}

	private invokeRegisteredMobileNumber(): void {
		if (!this.appResponse.appInfo.appId) return;
		this.isLoading = true;
		ExistingOnboardingCustomerService.getRegisteredMobileNumbers(
			this.getMobileNumberRequest.appId
		)
			.pipe(finalize(() => (this.isLoading = false)))
			.subscribe(
				(result) => this.handleRegisteredMobileNumberResponse(result),
				(error) => this.handleError(error, SourceApis.Onboarding)
			);
	}
	private handleRegisteredMobileNumberResponse(response: IGetRegisteredMobileNumbersResponse) {
		if (!!response) {
			this.activeModal.close();
			const modalRef = this.modalService.open(ContactInfoModalComponent, {
				windowClass: 'modal-small',
			});
			(
				modalRef.componentInstance as ContactInfoModalComponent
			).getRegisteredMobileNumbersResponse = new GetRegisteredMobileNumbersResponse(response);
			(modalRef.componentInstance as ContactInfoModalComponent).appCreateAppResponse =
				new CreateApplicationResponse(this.appResponse);
			(modalRef.componentInstance as ContactInfoModalComponent).isCardModalflow =
				this.isCardModalflow;
			(
				modalRef.componentInstance as ContactInfoModalComponent
			).isForgetCredentialsRetailModalflow = this.isForgetCredentialsRetailModalflow;
		}
	}
	private handleError(error: IErrorDescription, sourceApi: SourceApis): void {
		ErrorHandler.newError(error, sourceApi);
	}
	private initRequests(): void {
		this.getMobileNumberRequest = {
			appId: this.appResponse.appInfo.appId,
		};
	}
	private nullableCheck(): void {
		if (
			!!this.appResponse &&
			!!this.appResponse.appData &&
			!!this.appResponse.appInfo &&
			!!this.appResponse.appData.personalDetails &&
			!!this.appResponse.appData.idNo &&
			!!this.appResponse.appInfo.appId
		) {
			this.firstname = this.appResponse.appData.personalDetails.firstName;
			this.lastname = this.appResponse.appData.personalDetails.lastName;
			this.dateOfBirth = this.appResponse.appData.personalDetails.dateOfBirth;
			this.fathersName = this.appResponse.appData.personalDetails.fathersName;
			this.idNumber = this.appResponse.appData.idNo;
			this.taxNumber = this.appResponse.appData.personalDetails.taxId;
		} else {
			this.firstname = '-';
			this.lastname = '-';
			this.dateOfBirth = '-';
			this.fathersName = '-';
			this.idNumber = '-';
			this.taxNumber = '-';
		}
	}
}
